<template>
    <div>
        <div class="grid grid-cols-[auto_auto_auto] gap-x-12 gap-y-2 w-fit items-center text-sm">
            <span class="font-semibold col-span-2">Kolonner fra system</span>
            <span class="font-semibold">Kolonner fra fil</span>

            <template v-for="(colIndex, colKey) in columnMapping" :key="colKey">
                <div data-test="column-name">
                    {{ dataGridColumnNameFromKey(colKey) }}
                </div>
                <i class="i-ph-arrow-right text-lg" />
                <USelect
                    v-model="colIndex as number"
                    data-test="column-selector"
                    label-key="value"
                    value-key="index"
                    class="min-w-[200px]"
                    :items="sampleRowObjects"
                    :ui="{
                        content: 'z-10'
                    }"
                    @update:model-value="(index: number | undefined) => updateMappingForColumn(colKey, index)"
                >
                    <template #default>
                        <div class="flex items-center gap-1">{{ sampleRowObjects[colIndex]?.value || ('Kolonne: ' + colIndex) }}</div>
                    </template>
                </USelect>
            </template>
        </div>
        <div class="flex justify-between mt-2">
            <div class="flex items-center gap-2 text-sm">
                <UCheckbox id="firstColumnHeadersToggle" v-model="firstRowIsHeader"/>
                <label for="firstColumnHeadersToggle">Første rad er overskrift</label>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {CsvDataRow} from '@/incoming-balance/types/CsvDataRow.type'
import {DataGridColumnDefinition} from '@/incoming-balance/types/DataGridColumnDefinition.type'
import {ColumnMapping} from '@/incoming-balance/types/ColumnMapping.type'

const props = defineProps({
    sampleRow: {
        type: Array as () => CsvDataRow,
        required: true
    },
    dataGridColumns: Array as () => DataGridColumnDefinition
})

const sampleRowObjects = computed(() => {
     const options = props.sampleRow?.map((value, index) => {
         if(index === 0) return {index, value: ''}
        return {
            index,
            value: value == '' ? ('Kolonne: ' + index) : value,
        }
    })

    return [...options, {index: props.sampleRow?.length, value: ' - '}]
})

const emit = defineEmits(['mapping-changed'])

const dataGridColumnNameFromKey = (key: string): string => {
    const column = props.dataGridColumns?.find(col => col.field === key)
    return column ? column.headerName || '' : key
}

const columnMapping = defineModel<ColumnMapping>({required: true})
const firstRowIsHeader = defineModel<boolean>('firstRowIsHeader', {default: false})

const updateMappingForColumn = (key: string, index: number | undefined) => {
    if(!index) return
    columnMapping.value[key] = index
    emit('mapping-changed')
}

</script>

<style scoped>

</style>